import React, { useEffect, useState } from 'react';
import useToken from '../../useToken'
import { makeStyles } from '@material-ui/styles';
import { useSelector, useDispatch } from 'react-redux';
import { fetchWeather } from '../../features/weather/weatherSlice';
import { parse, format } from "date-fns";
import DataTable from 'react-data-table-component';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import clear_day from '../../assets/clear_day.png'
import light_rain from '../../assets/light_rain.jpg';
import mid_rain from '../../assets/mid_rain.jpg';
import heavy_rain from '../../assets/heavy_rain.jpg';
import './Weather.css'
import { useAuth } from '../../contexts/AuthContext'

const useStyles = makeStyles({
  pos: {
    marginRight: 15,
  },
});

export default function Weather() {
  const classes = useStyles();
  const {token, setToken} = useToken()
  const { logout } = useAuth()
  const dispatch = useDispatch()
  const weather = useSelector((state: any) => state.weather.weatherData);

  if (weather.error === "unauthorized") {
      logout()
      window.location.reload();
  }

    useEffect(() => {
      dispatch(fetchWeather({token}))
    }, [dispatch]);

  const weatherData = weather.data
  
  const WeatherImage = (props) => {
    let image = clear_day
    if (props.forecast === "Clear") {
      image = clear_day
    } else if (props.forecast === "Light") {
      image = mid_rain
    } else if (props.forecast === "Mid") {
      image = mid_rain
    } else if (props.forecast === "Heavy") {
      image = heavy_rain
    }

    let cssType = "img"
    if (props.type === "small") {
      cssType = "sml_img"
    }
    return(
      <img className={cssType} src={image}/>
    )
  }

  const fourDaysForecasts = []
  let forecasts = weatherData.FourDaysForecast || {}
  for (let key in forecasts) {
    let buffer = {}
    buffer["day"] = format(parse(key, "yyyy-LL-dd", new Date()), "EEEE")
    buffer["forecast"] = forecasts[key]
    fourDaysForecasts.push(buffer)
  }

  const ForecastsListItems = () => {
    return fourDaysForecasts.map((forecast)=>{
      return(
      <div key={forecast.day}>
      <ListItem>
        <ListItemText primary={forecast.day}/>
        <WeatherImage type="small" forecast={forecast.forecast}/>
      </ListItem>
      <Divider />
      </div>
      )
    })
  }

  return (
    <React.Fragment>
      <Card>
        <CardContent>
        <List>
          <ListItem>
          <Typography variant="h6">
            Nowcast
          </Typography>
          <WeatherImage type="norm" forecast={weatherData.Forecast} />
          <Typography variant="body1" className={classes.pos}>
            {weatherData.AirTemp}&deg;C
          </Typography>
          <Typography variant="body2">
            {weatherData.NEA}
          </Typography>
          </ListItem>
          <Divider/>
          <ListItem id="day">
            <ListItemText primary="Today"/>
            <WeatherImage type="small" forecast={weatherData.DayForecast}/>
          </ListItem>
          <Divider />
          <ForecastsListItems />
        </List>
         </CardContent>
        </Card>
    </React.Fragment>
  );
}
